export default __webpack_public_path__ + "static/media/quickIcon.aa0f5ef5.svg";